import React from 'react';
import Intro from '@components/events/eventChallenge/intro';
import Challenge from '@components/events/eventChallenge/challenge';
import ChallengeMission1 from '@components/events/eventChallenge/challengeMission1';
import ChallengeMission2 from '@components/events/eventChallenge/challengeMission2';
import JobdaMatchBanner from '@components/events/eventChallenge/jobdaMatchBanner';
import ExtraBenefit from '@components/events/eventChallenge/extraBenefit';
import Interview from '@components/events/eventChallenge/interview';
import Catchphrase from '@components/events/eventChallenge/catchphrase';
import { useEventsTalentPoolUserStatus } from '@repository/event/useEvent';
import { useUserInfo } from '@repository/auth/useUserInfo';
import EventChallengeModalWrap from '@components/events/eventChallenge/modalsWrap';

const EventChallenge = () => {
  const { data: userData } = useUserInfo();
  const isLogin = !!userData?.id;

  const { data, refetch: eventsTalentPoolUserStatusReFetch } = useEventsTalentPoolUserStatus(isLogin);

  return (
    <EventChallengeModalWrap>
      {/* 인트로 영역 */}
      <Intro />

      {/* 잡다 챌린지 설명 영역 */}
      <Challenge />

      {/* 잡다 챌린지 미션 1 영역 */}
      <ChallengeMission1 isLogin={isLogin} talentPoolEventData={data} onReFetch={eventsTalentPoolUserStatusReFetch} />

      {/* 잡다 챌린지 미션 2 영역 */}
      <ChallengeMission2 isLogin={isLogin} talentPoolEventData={data} onReFetch={eventsTalentPoolUserStatusReFetch} />

      {/* 챌린지 플러스 - 잡다매칭 배너 영역 */}
      <JobdaMatchBanner />

      {/* 추가 증정 이벤트 */}
      <ExtraBenefit />

      {/* 합격자 인터뷰 영역 */}
      <Interview />

      {/* 캐치프레이즈 영역 */}
      <Catchphrase />
    </EventChallengeModalWrap>
  );
};

export default EventChallenge;
